module.exports = __webpack_public_path__ + "static/media/esb.defc8335.png";